import axios from 'axios';
import { Transaction } from '@/types/Transaction';
import { getBaseUrl } from '../../config/api'; // Adjust the import if needed
import { TransactionPage } from '@/types/TransactionTableDTO';
export interface MonthlyBreakdownDTO {
  label: string;
  total: number;
}

export interface CategoryBreakdownDTO {
  name: string;
  total: number;
}

export interface MerchantSummary {
  totalTransactions: number;
  totalAmount: number;
  averageAmount: number;
  monthlyBreakdown: MonthlyBreakdownDTO[];
  categoryBreakdown: CategoryBreakdownDTO[];
}

export interface MerchantDrilldownResponse {
  summary: MerchantSummary;
  transactions: Transaction[];
}

export const fetchMerchantDrilldown = async (
  merchantName: string,
  timeframe: string,
  date: string
): Promise<MerchantDrilldownResponse> => {
  const baseUrl = getBaseUrl(); // ✅ resolves to http://localhost:8081/api
  const url = `${baseUrl}/transactions/merchant-drilldown/${encodeURIComponent(
    merchantName
  )}?timeframe=${timeframe}&date=${date}`;

  const response = await axios.get<MerchantDrilldownResponse>(url, {
    withCredentials: true, // ✅ in case you're using cookies/JWT in a secure session
  });

  return response.data;
};


// ✅ New Function
export const fetchTransactionTable = async (
  page = 0,
  size = 50,
  filters: Record<string, string | number> = {}
): Promise<TransactionPage> => {
  const url = new URL(`${getBaseUrl()}/transactions`);
  url.searchParams.append('page', page.toString());
  url.searchParams.append('size', size.toString());

  Object.entries(filters).forEach(([key, value]) => {
    url.searchParams.append(key, String(value));
  });

  const response = await axios.get<TransactionPage>(url.toString(), {
    withCredentials: true,
    // timeout: API_CONFIG.TIMEOUT,
    // headers: API_CONFIG.HEADERS,
  });

  return response.data;
};
